/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */

import React, {useState} from 'react';
import {Modal, LargeButton, Loader, InputComponent, Label, TextWarning, InputCheckbox} from '../../../../components';
import {CardForm, CardWrapper, SetDefaultComponent} from './styles';
import {InputWrapper} from '../../../config/styles';
import {useInputValue} from '../../../../utils/hooks/useInputValue';
import {Admin, Utils} from '../../../../utils/api';

const CheckoutForm = ({handleModalFunction, refreshCards, card}: {handleModalFunction: Function; refreshCards: any; card: any}) => {
  const [processing, setProcessing] = useState(false);
  const [defaultCard, useDefault] = useState(card.default);
  const nameInput = useInputValue(card.name);
  const yearInput = useInputValue(card.year);
  const monthInput = useInputValue(card.month);
  const ADMIN = new Admin();
  const utils = new Utils();
  const validateInput = utils.GetValidationInputPattern();
  const validateNumber = utils.GetValidationNumbers();

  const handleSubmit = async event => {
    event.preventDefault();

    if (!validatedFirstName()) {
      return;
    }

    if (!validatedYear()) {
      return;
    }

    if (!validatedMonth()) {
      return;
    }
    if (!validateCurrentDate()) {
      return;
    }
    setProcessing(true);

    let data = {
      id: card.id,
      default: defaultCard,
      name: nameInput.value,
      card: {
        year: yearInput.value,
        month: monthInput.value,
      },
    };
    const response: any = await ADMIN.EditCard(data);
    if (response.status) {
      setProcessing(false);
      reset();
    } else {
      setProcessing(false);
    }
  };

  const reset = () => {
    handleModalFunction(false);
    refreshCards();
  };
  function HandleFocus(input: any) {
    input.HandleWarning('');
    input.HandleStatus('normal');
  }
  function validateCurrentDate(): boolean {
    const cardDate = new Date(yearInput.value, monthInput.value);
    const actualDate = new Date();
    if (cardDate < actualDate) {
      yearInput.HandleWarning('Please enter a valid year');
      yearInput.HandleStatus('error');
      monthInput.HandleWarning('Please enter a valid month');
      monthInput.HandleStatus('error');

      return false;
    } else {
      monthInput.HandleWarning('');
      monthInput.HandleStatus('normal');
      yearInput.HandleWarning('');
      yearInput.HandleStatus('normal');
      return true;
    }
  }
  function validatedFirstName(): boolean {
    if (Number(nameInput.value.length) === 0 || !Boolean(validateInput.test(nameInput.value))) {
      nameInput.HandleWarning('Please enter a valid name');
      nameInput.HandleStatus('error');

      return false;
    } else {
      nameInput.HandleWarning('');
      nameInput.HandleStatus('normal');
      return true;
    }
  }
  function validatedYear(): boolean {
    if (Number(yearInput.value.length) === 0 || !Boolean(validateNumber.test(yearInput.value))) {
      yearInput.HandleWarning('Please enter a valid year');
      yearInput.HandleStatus('error');
      return false;
    } else {
      yearInput.HandleWarning('');
      yearInput.HandleStatus('normal');
      return true;
    }
  }
  function validatedMonth(): boolean {
    if (
      monthInput.value > 12 ||
      monthInput.value < 0 ||
      Number(monthInput.value.length) === 0 ||
      !Boolean(validateNumber.test(monthInput.value))
    ) {
      monthInput.HandleWarning('Please enter a valid month');
      monthInput.HandleStatus('error');
      return false;
    } else {
      monthInput.HandleWarning('');
      monthInput.HandleStatus('normal');
      return true;
    }
  }

  return (
    <>
      <CardForm>
        <CardWrapper>
          <InputWrapper>
            <Label
              text="FULL NAME"
              color={'rgba(93,110,129,1);margin-top:0px;  letter-spacing: 0.66px;line-height: 25.2px;'}
              fontWeight={'600'}
              fontSize={'12'}
            />

            <InputComponent animateWidth="100%" dynamicSearch={nameInput} HandleFocus={() => HandleFocus(nameInput)} />
            <TextWarning status={nameInput.status} message={nameInput.warningMessage} display={';font-size:14px;margin-top:0px'} />
          </InputWrapper>
          <InputWrapper>
            <Label
              text="Month"
              color={'rgba(93,110,129,1);margin-top:0px;  letter-spacing: 0.66px;line-height: 25.2px;'}
              fontWeight={'600'}
              fontSize={'12'}
            />

            <InputComponent animateWidth="100%" dynamicSearch={monthInput} HandleFocus={() => HandleFocus(monthInput)} />
            <TextWarning status={monthInput.status} message={monthInput.warningMessage} display={';font-size:14px;margin-top:0px'} />
          </InputWrapper>
          <InputWrapper>
            <Label
              text="Year"
              color={'rgba(93,110,129,1);margin-top:0px;  letter-spacing: 0.66px;line-height: 25.2px;'}
              fontWeight={'600'}
              fontSize={'12'}
            />

            <InputComponent animateWidth="100%" dynamicSearch={yearInput} HandleFocus={() => HandleFocus(yearInput)} />
            <TextWarning status={yearInput.status} message={yearInput.warningMessage} display={';font-size:14px;margin-top:0px'} />
          </InputWrapper>
        </CardWrapper>

        {!card.default && (
          <SetDefaultComponent>
            <InputCheckbox checked={defaultCard} onClick={() => useDefault(!defaultCard)} /> <span>Set as default payment method.</span>
          </SetDefaultComponent>
        )}
      </CardForm>

      <hr style={{border: '0.5px solid rgba(186, 193, 201, 0.22)', margin: 0}} />
      {!processing ? (
        <LargeButton
          callback={handleSubmit}
          lColor="#006BE1"
          rColor="rgba(0,122,255,1)"
          icon="done"
          title="SAVE CARD"
          xMargin={'35px 50px 35px auto'}
        />
      ) : (
        <Loader width="186px" height="50px" />
      )}
    </>
  );
};

export const EditCardModal = ({
  handleModalFunction,
  refreshCards,
  card,
}: {
  handleModalFunction: Function;
  refreshCards: any;
  card: any;
}) => {
  return (
    <Modal title="Edit card" margin={'30px auto'}>
      <CheckoutForm handleModalFunction={handleModalFunction} refreshCards={refreshCards} card={card} />
    </Modal>
  );
};
